<template>
    <div>
        <div v-if="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <app-form v-bind:parentObject="{
                // data: this.formData,
                searchnew: this.search,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.isEdit,
            }" v-on:input="formData = $event" v-on:error="errorHandler" />

            <div v-if="isErr">
                <app-error v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }" v-on:closeError="isErr = $event" />
            </div>
        </div>
    </div>
</template>

<script>
import ModerationRecordForm from "../../../components/performance/moderationrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": ModerationRecordForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            search: this.$route.params.search,
            pageTitle: this.$t('pmmoderation.pmmoderationprocess'),
            pageTitleValue: "",
            formData: {
                // id: null,
                // pmassessmentrecordcode: null,
                // pmassessmentrecorddesc: null,
                // startdate: null,
                // enddate: null,
                // // cutoffdate: null,
                // // statusid: null,
                // // ratingtype: null,
                // ratingid: null,
                // // remark: null,
                // // pmassecalmethodid: null,
                // stamp: null,
                // userid: this.$store.getters.userId,
            },
            errMsg: "",
            isErr: false,
            loading: true,
            isEdit: false,
            
            isConfirm: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },


    },

    async mounted() {
        try {
            this.loading = false; // Set loading to false after all data is loaded
        } catch (error) {
            console.error("Something went wrong during mounted:", error);
            this.isErr = true;
            this.errMsg = error;
        }
    }
};
</script>